export default {
      id: "emerald-usage",
      viewBox: "0 0 21 30",
      url: __webpack_public_path__ + "icons.svg#emerald",
      toString: function () {
        return this.url;
      }
    }